<template>
  <div v-show="show" @click.self="dismiss" class="modal-bg">
    <div class="modal">

      <h1 class="txt-bold">Tekijätiedot</h1>
      <br>
      <h2 class="mb-1">Sovelluskehitys ja sisältö pääosin:</h2>
      <p>Juuso Heino</p>
      <p>Katja Maununaho</p>
      <p>Sini Saarimaa</p>
      <p>Jyrki Tarpio</p>
      <p>Tommi Teronen</p>
      <p>(ASUTUT-tutkimusryhmä / Tampereen yliopisto)</p>
      <br>
      <h2 class="mb-1">Muita yksittäisten osioiden laatijoita:</h2>
      <p>Elina Alatalo</p>
      <p>Liisa Häikiö</p>
      <p>Mikko Kyrönviita</p>
      <p>Markus Laine</p>
      <p>Santtu Lehtinen</p>
      <p>Helena Leino</p>
      <p>Henna Luoma-Halkola</p>
      <p>Jouko Myllyoja</p>
      <p>Juha Peltomaa</p>
      <p>Liina Sointu</p>
      <p>Anu Tuominen</p>
      <p>Nina Wessberg</p>
      <p>Maria Åkerman</p>
      <p>(VTT, Syke, Tampereen yliopisto)</p>
      <br>
      <h2 class="mb-1">Päävastuu sisällöstä:</h2>
      <p>Jyrki Tarpio</p>
      <br>
      <h2 class="mb-1">Sovelluskehitys ja ylläpito:</h2>
      <p>Juuso Heino / 5MAG Entertainment</p>
      <br>
      <p>Sovellus on kehitetty Suomen Akatemian Strategisen tutkimuksen neuvoston rahoittamassa Ketterä kaupunki (DAC) -tutkimushankkeessa (projektinumero 303481).</p>
      <br>

      <button @click="dismiss" class="btn txt-center">Sulje</button>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
      // default: false
    }
  },

  data () {
    return {

    }
  },

  created () {
    const escapeHandler = e => {
      if (e.key === 'Escape' && this.show) {
        this.dismiss()
      }
    }
    document.addEventListener('keydown', escapeHandler)
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler)
    })
  },

  methods: {
    dismiss () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
</style>
